export default "__VITE_ASSET__r3fDB8OP__"